import deleteIcon from '@/assets/images/login/ykylogin/delete.png'
import GLOBAL_ENUM from './enum'

const STAMP_CODE = {
  CODES: [
    {
      key: 0
    },
    {
      key: 1
    },
    {
      key: 2
    },
    {
      key: 3
    },
    {
      key: 4
    },
    {
      key: 5
    }
  ],
  KEYBOARDS: [
    {
      key: '1',
      type: GLOBAL_ENUM.KEYBOARDS_TYPE.NUM
    },
    {
      key: '2',
      type: GLOBAL_ENUM.KEYBOARDS_TYPE.NUM
    },
    {
      key: '3',
      type: GLOBAL_ENUM.KEYBOARDS_TYPE.NUM
    },
    {
      key: '4',
      type: GLOBAL_ENUM.KEYBOARDS_TYPE.NUM
    },
    {
      key: '5',
      type: GLOBAL_ENUM.KEYBOARDS_TYPE.NUM
    },
    {
      key: '6',
      type: GLOBAL_ENUM.KEYBOARDS_TYPE.NUM
    },
    {
      key: '7',
      type: GLOBAL_ENUM.KEYBOARDS_TYPE.NUM
    },
    {
      key: '8',
      type: GLOBAL_ENUM.KEYBOARDS_TYPE.NUM
    },
    {
      key: '9',
      type: GLOBAL_ENUM.KEYBOARDS_TYPE.NUM
    },
    {
      key: '清空',
      type: GLOBAL_ENUM.KEYBOARDS_TYPE.CLEAR
    },
    {
      key: '0',
      type: GLOBAL_ENUM.KEYBOARDS_TYPE.NUM
    },
    {
      key: deleteIcon,
      type: GLOBAL_ENUM.KEYBOARDS_TYPE.DELETE
    }
  ]
}

const THEME_BACKGROUND_COLOR = {
  [GLOBAL_ENUM.THEME_TYPE.DEFAULT_THEME]: 'rgba(248, 248, 248, 1)',
  [GLOBAL_ENUM.THEME_TYPE.TRANSPARENT_THEME]: 'transparent',
  [GLOBAL_ENUM.THEME_TYPE.LINEAR_GRADIENT_THEME]:
    'linear-gradient( 180deg, #E1E2E9 0%, rgba(255,255,255,0) 100%)'
}

const OCR_FILE_STATUS_TURN_COMPONENT = {
  1: GLOBAL_ENUM.OCR_PAGE_TYPE.ORIGINAL_ATTACHMENT_PREVIEW,
  2: GLOBAL_ENUM.OCR_PAGE_TYPE.AFTER_VERIFICATION_PREVIEW,
  3: GLOBAL_ENUM.OCR_PAGE_TYPE.AFTER_VERIFICATION_PREVIEW,
  4: GLOBAL_ENUM.OCR_PAGE_TYPE.AFTER_VERIFICATION_PREVIEW,
  5: GLOBAL_ENUM.OCR_PAGE_TYPE.ORIGINAL_ATTACHMENT_PREVIEW,
  7: GLOBAL_ENUM.OCR_PAGE_TYPE.OCR_MANUAL_APPROVAL
}

//ocr类型对印的校验页面 1单份 2单页 3整份 4整份扫描仪
const OCR_TYPE_TURN_CHECK_PAGE = {
  [GLOBAL_ENUM.OCR_TYPE.SINGLE_COPY]: GLOBAL_ENUM.OCR_CHECK_PAGE_TYPE.SINGLE_WHOLE_CHECK_PAGE,
  [GLOBAL_ENUM.OCR_TYPE.SINGLE_PAGE]: GLOBAL_ENUM.OCR_CHECK_PAGE_TYPE.SINGLE_PAGE_CHECK_PAGE,
  [GLOBAL_ENUM.OCR_TYPE.WHOLE_COPY]: GLOBAL_ENUM.OCR_CHECK_PAGE_TYPE.SINGLE_WHOLE_CHECK_PAGE,
  [GLOBAL_ENUM.OCR_TYPE.WHOLE_COPY_AND_SCAN]: GLOBAL_ENUM.OCR_CHECK_PAGE_TYPE.SINGLE_WHOLE_CHECK_PAGE,
}


// 1单份 2单页 3整份 4整份扫描仪
const OCR_NUM_TURN_OCR_TYPE = {
  1: GLOBAL_ENUM.OCR_TYPE.SINGLE_COPY,
  2: GLOBAL_ENUM.OCR_TYPE.SINGLE_PAGE,
  3: GLOBAL_ENUM.OCR_TYPE.WHOLE_COPY,
  4: GLOBAL_ENUM.OCR_TYPE.WHOLE_COPY_AND_SCAN,
}


const YKY_CAMERA_CONFIG = {
  analyzeSize: [960, 720],
  captureSize: [3264, 1840],
  previewSize: [2048,1536],
  recordSize: [960, 720],
}

export default {
  STAMP_CODE,
  THEME_BACKGROUND_COLOR,
  OCR_FILE_STATUS_TURN_COMPONENT,
  OCR_TYPE_TURN_CHECK_PAGE,
  OCR_NUM_TURN_OCR_TYPE,
  YKY_CAMERA_CONFIG
}
